import { get as apiGet, put as apiPut } from './apiService';
import { Invitation, InvitationType } from '../types/invitation';

// Get all unacknowledged invitations
export async function getUnacknowledgedInvitations(): Promise<Invitation[]> {
  return apiGet<Invitation[]>('/invitation/nack');
}

// Accept or reject an invitation
export async function acceptReject(
  type: InvitationType,
  id: string,
  action: 'accept' | 'reject'
): Promise<void> {
  return apiPut<void>(`/invitation/${type}/${id}/${action}`, {});
}

// Convenience export
export const invitationService = {
  getUnacknowledgedInvitations,
  acceptReject,
};
